import { CommentsQuestion } from './comments-question';

export interface CommentsSection {
  sectionName: string;
  commentsQuestions: CommentsQuestion[];
}
